export default "__VITE_ASSET__b9da2b9e__"